module.exports = __webpack_public_path__ + "static/img/device-orb.8924220.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/device-orb.png
// module id = 425
// module chunks = 0